<template>
	<div class="close_button">
		<div class="inner">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="18.031"
				height="18.374"
				viewBox="0 0 18.031 18.374"
			>
				<g
					id="Exit"
					transform="translate(-267.487 -1366.303)"
				>
					<line
						id="Line_2"
						data-name="Line 2"
						x2="24"
						transform="translate(268.018 1383.803) rotate(-45)"
						fill="none"
						stroke="#2c584e"
						stroke-width="1.5"
					/>
					<line
						id="Line_1"
						data-name="Line 1"
						x2="24"
						transform="translate(268.018 1367.176) rotate(45)"
						fill="none"
						stroke="#2c584e"
						stroke-width="1.5"
					/>
				</g>
			</svg>

		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.close_button {
	width: 40px;
	height: 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	transition: 0.2s ease all;

	@media (max-width: $mobile-xl) {
		width: 32px;
		height: 32px;
	}

	.inner {
		/* border: var(--border); */
		width: 28px;
		height: 28px;
		border-radius: 50%;
		/* background: var(--gum-green); */
		transition: 0.2s ease all;
		display: flex;
		justify-content: center;
		align-items: center;

		&:hover {
			width: 32px;
			height: 32px;
			transition: 0.2s ease all;
			cursor: pointer;
		}

		img {
			width: 18px;
			height: 18px;
		}

		svg {
			rect {
				fill: var(--clay-brown);

				.search_dropdown & {
					fill: var(--gum-green);
				}
			}

			line {
				stroke: var(--sand);

				.search_dropdown & {
					stroke: var(--gum-green);
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/CloseButton.vue